import { PrimeTrialPromoApiResponse, PrimeTrialPromoModalProps } from './types';

type PrimeTrialPromoModalData = Omit<
  PrimeTrialPromoModalProps,
  'open' | 'onClose' | 'onJoinPrime'
>;

export default function mapPrimeTrialPromoResponseToModalData(
  response: PrimeTrialPromoApiResponse
): PrimeTrialPromoModalData {
  return {
    heroVideoUrl: response.videoUrl,
    brandLogoSrc: '/static/images/logo_m.svg',
    primeLogoSrc: response.primeLogoUrl,
    priceImageSrc: response.priceImageUrl,
    headline: response.contextualText.primaryText,
    thenLine:
      response.contextualText.tertiaryText ??
      response.contextualText.secondaryText,
    primaryCtaLabel: response.ctaDetails.ctaPriceText,
    benefits: response.benefits.map((benefit) => ({
      logoSrc: benefit.logoUrl,
      title: benefit.subTitle,
      subtitle: benefit.title
    }))
  };
}
